import API from './API';

// 로그아웃
export const postLogout = () => {
  return API.post('/auth/revoke');
};

// 로봇 수정
export const patchRobot = (robotId, data) => {
  return API.patch(`/robots/${robotId}`, data);
};

// 프로젝트 내역 조회
export const getProjects = () => {
  return API.get('/projects');
};

// 프로젝트 생성
export const createProject = (name) => {
  return API.post('/projects', { name });
};

// 프로젝트 수정
export const updateProject = (projectId, name) => {
  return API.patch(`/projects/${projectId}`, { name });
};

// 프로젝트 삭제
export const deleteProject = (projectId) => {
  return API.delete(`/projects/${projectId}`);
};

// 미션 생성
export const createMission = (projectId, name, json) => {
  return API.post('/missions', { projectId, name, json });
};

// 미션 조회
export const getMission = (missionId) => {
  return API.get(`/missions/${missionId}`);
};

// 미션 수정
export const updateMission = (missionId, name, json) => {
  return API.patch(`/missions/${missionId}`, { name, json });
};

// 미션 삭제
export const deleteMission = (missionId) => {
  return API.delete(`/missions/${missionId}`);
};
